import { clsx } from '../vendor/clsx/dist/clsx.mjs';
import { twMerge } from '../vendor/tailwind-merge/dist/bundle-mjs.mjs';

function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export { cn };
